<a href="javascript:void(0)" class="closebtn" (click)="showhideFilters()"
  >&times;</a
>
<h2
  class="sidenav-ttile d-flex justify-content-between align-items-center px-4 py-2 mb-0"
>
  {{ "FILTERS" | translate }}
</h2>

<div id="accordion">
  <dq-accordion id="products" icon="icon-producto.svg" label="PRODUCT">
    <div class="card-body">
      <dq-combo
        id="brandCombo"
        [items]="brands"
        (selectedItemEvent)="changeBrand($event)"
        label="Brand"
      ></dq-combo>

      <dq-combo
        id="subBrandCombo"
        [items]="subbrands"
        (selectedItemEvent)="changeSubBrand($event)"
        label="Sub Brand"
      ></dq-combo>

      <dq-combo id="lineCombo" [items]="lines" label="Línea"></dq-combo>
      <dq-combo id="formatCombo" [items]="[]" label="Formato"></dq-combo>
    </div>
  </dq-accordion>
</div>
